export enum ObjectTypes {
    SubmittedKit = 1,
    SubmittedKitRun = 2,
    Lab = 3,
    Pipet = 4,
    Operator = 5
}

export const ObjectTypeNames = [
    { id: 0, name: "" },
    { id: 1, name: "Submitted Kit" },
    { id: 2, name: "Submitted Kit Run", linkTo: "/submitted-kit-run-manage/" },
    { id: 3, name: "Lab" },
    { id: 4, name: "Pipet" },
    { id: 5, name: "Operator" },
]

export enum CommentType {
    ManuallyCreated = 1,
    AutomaticallyGenerated = 2,
    SentBack = 3,
    UnlockKit = 4,
    SetToError = 5,
    Reran = 6,
    ManuallyIncludedRun = 7,
    ManuallyExcludedRun = 8,
}

export const CommentTypeNames = [
    { id: 0, name: "" },
    { id: 1, name: "Manually Created" },
    { id: 2, name: "Automatically Generated" },
    { id: 3, name: "Sent Back" },
    { id: 4, name: "Unlock Kit" },
    { id: 5, name: "Set To Error" },
    { id: 6, name: "Reran" },
    { id: 7, name: "Manually Included Run" },
    { id: 8, name: "Manually Excluded Run" },
]